import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { ellipsify } from '../../typography/ellipsify';
import { useTheme } from '../../theming/useTheme';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';
import { BaseUnit } from '../../theming/baseUnitDefinition';

export const CARD_CAPTION_CONTAINER_TYPES = {
  HORIZONTAL: 'horizontal',
  ON_TOP: 'onTop',
  VERTICAL: 'vertical',
  DEFAULT: 'default',
};

interface CardCaptionContainerComponentDataProps {
  numberOfLines: number
  type: string
}

interface CardCaptionContainerComponentThemeProps {
  baseUnit: BaseUnit
}

type CardCaptionContainerComponentProps = CardCaptionContainerComponentDataProps & CardCaptionContainerComponentThemeProps;

const createStyles = (baseUnit: BaseUnit) => StyleSheet.create({
  [CARD_CAPTION_CONTAINER_TYPES.DEFAULT]: {
    overflow: 'hidden',
  },
  [CARD_CAPTION_CONTAINER_TYPES.ON_TOP]: {
    background: 'transparent',
    position: 'absolute',
    bottom: 0,
    margin: `${baseUnit * 0.5}px`,
  },
  [CARD_CAPTION_CONTAINER_TYPES.HORIZONTAL]: {
    flex: '1 1 66%',
    position: 'relative',
    margin: `${baseUnit * 0.5}px`,
    [MEDIA_BREAKPOINTS.MEDIUM]: {
      '-webkitLineClamp': '2',
    },
    [MEDIA_BREAKPOINTS.SMALL]: {
      '-webkitLineClamp': '3',
      flex: '0 0 66.66%',
    },
  },
  [CARD_CAPTION_CONTAINER_TYPES.VERTICAL]: {
    margin: `${baseUnit * 0.5}px`,
  },
});

export const CardCaptionContainerComponent: React.FunctionComponent<CardCaptionContainerComponentProps> = ({ numberOfLines, children, type, baseUnit }) => {
  const cardStyles = createStyles(baseUnit);
  // @ts-ignore TS2345
  const { style } = StyleSheet.create(ellipsify(numberOfLines));

  return (
    <div className={css(
      style,
      cardStyles[CARD_CAPTION_CONTAINER_TYPES.DEFAULT],
      cardStyles[type],
    )}
    >
      {children}
    </div>
  );
};


const mapThemeProps = (theme: CardCaptionContainerComponentThemeProps) => ({
  baseUnit: theme.baseUnit,
});

export const CardCaptionContainer: React.FunctionComponent<CardCaptionContainerComponentDataProps> = props => {
  const themeContext = useTheme(mapThemeProps);
  return <CardCaptionContainerComponent {...themeContext} {...props} />;
};
